import React from 'react'
import LoginLogo from 'assets/img/brand/llogo.svg'

function AppLogo() {
  return (
    <div className="login-pic">
      <img src={LoginLogo} alt="IMG" />
    </div>
  )
}

export default AppLogo
